import { type UserBulkUpdateInput, type UserBulkUpdateSuccess, Logger } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'

const logger = new Logger('useUserBulkUpdate')

export function useUserBulkUpdate(): UpdateHookResponse<UserBulkUpdateInput, { updatedCount: number }> {
  logger.verbose('calling useUserBulkUpdate')
  const mutation = useTantalimMutation<UserBulkUpdateInput, UserBulkUpdateSuccess>({ url: '/user/update/bulk' })

  async function update(input: UserBulkUpdateInput): Promise<{ updatedCount: number }> {
    const response = await mutation.mutateAsync(input)
    logger.verbose('bulk updated users', response.updatedCount)
    return { updatedCount: response.updatedCount }
  }

  return mutationUpdate(mutation, update)
}
